module.exports = __webpack_public_path__ + "img/lauren-barry.22c18a2d.jpeg";